<template>
  <div class="container">
    <content-template>
      <template slot="left">線上常識問答比賽</template>
      <template slot="right">
        <li class="media-navbar">
          <router-link to="/common-sense">線上常識問答比賽</router-link>
        </li>
        <li class="media-navbar">
          <a class="is-check" style="color: #5571EC;">賽事名單公佈</a>
        </li>
        <li class="media-navbar media-navbar-none-margin nav-float-left">
          <router-link to="/all-question">過往題目</router-link>
        </li>
      </template>
      <template slot="banner">
        <img src="./banner.jpg" class="top-banner" alt="">
      </template>
      <template slot="content">
        <div class="col-xs-12" style="margin-top: 50px;">
          <template v-if="detail">
            <div class="release-time">{{detail.release_time}}</div>
            <div v-html="detail.events_list"></div>
          </template>
          <template v-else>
            <div style="font-size: 22px; color:rgba(139,139,139,1);text-align: center ">賽事名單還未公佈</div>
          </template>
        </div>
      </template>
    </content-template>
  </div>

</template>
<script>
import contentTemplate from '../contentTemplate'
export default {
  components: {
    'content-template': contentTemplate
  },
  data () {
    return {
      detail: '',
      registerTime: ''
    }
  },
  methods: {
    getOther: function () {
      var that = this
      this.$axios.get('/competition/events')
        .then(function (response) {
          that.detail = response.data.data
          console.log(that.detail)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  created () {
    this.getOther()
  }
}
</script>
<style scoped>
  .container {
    padding: 0px;
  }
  .release-time{
    font-size:18px;
    font-family:PingFangSC-Regular;
    color:rgba(139,139,139,1);
    line-height:25px;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/commonSense/nameList.vue